var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-more",
    clipPath: "url(#clip0_1966_5099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.321 15.5C13.7019 15.5 14.821 14.3808 14.821 13C14.821 11.6192 13.7019 10.5 12.321 10.5C10.9402 10.5 9.82104 11.6192 9.82104 13C9.82104 14.3808 10.9402 15.5 12.321 15.5Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7214 15.5C22.1023 15.5 23.2214 14.3808 23.2214 13C23.2214 11.6192 22.1023 10.5 20.7214 10.5C19.3406 10.5 18.2214 11.6192 18.2214 13C18.2214 14.3808 19.3406 15.5 20.7214 15.5Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.32104 15.5C4.70188 15.5 5.82104 14.3808 5.82104 13C5.82104 11.6192 4.70188 10.5 3.32104 10.5C1.94021 10.5 0.821045 11.6192 0.821045 13C0.821045 14.3808 1.94021 15.5 3.32104 15.5Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1966_5099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.221436 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsHover);
export default __webpack_public_path__ + "static/media/threedotsHover.6723fbb240e7e36726f8a44ef1f16258.svg";
export { ForwardRef as ReactComponent };